import UserContainer from './UserContainer'
import HamburgerContainer from './HamburgerContainer'

const NavRightResponsive = () => (
    <div className="nav-right">
        <ul className="horizontal-list">
            <li>
                <UserContainer isResponsive={true} />
            </li>
            <li>
                <HamburgerContainer />
            </li>
        </ul>
    </div>
)

export default NavRightResponsive
